import { CategoriaProducto } from "../types/categoria-producto.type";
import { Producto } from "../types/producto";
import ApiService from "./apiService";

const endpoint = "/api/v1/negocios/categorias-productos";

class CategoriasProductosService extends ApiService {
  getOne(categoriaProductoId: number) {
    return this.get<CategoriaProducto>(`${endpoint}/${categoriaProductoId}`, {
      negocioActivo: true,
    });
  }

  getAll() {
    return this.get<CategoriaProducto[]>(endpoint, {
      negocioActivo: true,
    });
  }

  create(nombre: string) {
    return this.post<CategoriaProducto>(
      endpoint,
      { nombre },
      {
        negocioActivo: true,
      }
    );
  }

  update(categoriaProductoId: number, nombre: string) {
    return this.put<CategoriaProducto>(
      `${endpoint}/${categoriaProductoId}`,
      {
        nombre,
      },
      {
        negocioActivo: true,
      }
    );
  }

  getProductos(categoriaProductoId: number) {
    return this.get<Producto[]>(`${endpoint}/${categoriaProductoId}/productos`, {
      negocioActivo: true,
    });
  }

  delete(categoriaProductoId: number) {
    return this.del(`${endpoint}/${categoriaProductoId}`, {
      negocioActivo: true,
    });
  }

  sort(categoriasIds: number[]) {
    return this.post(
      `${endpoint}/sort`,
      {
        categorias: categoriasIds,
      },
      {
        negocioActivo: true,
      }
    );
  }
}

const categoriasProductosService = new CategoriasProductosService();
export default categoriasProductosService;
